module.exports = __webpack_public_path__ + "img/stargleamcavern.a701709b.png";